import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { slideInAnimation } from '@app/layout/animations/slideInAnimation';
import { UntilDestroy } from '@ngneat/until-destroy';

import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';

@UntilDestroy()
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [NavbarComponent, RouterOutlet, SidebarComponent],
  animations: [slideInAnimation],
})
export class LayoutComponent implements AfterViewInit {
  constructor(private cdRef: ChangeDetectorRef) {}

  prepareRoute(outlet: RouterOutlet): any {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }
}
